import React, {useState, Fragment, useCallback, useEffect} from 'react';
import {translate} from '../Services/translation';
import {useSelector} from 'react-redux';
import CartItemRow from "./CartItemRow";

const Cart = () => {
    const cart = useSelector((state) => state.cart);
    const [orderRows, setOrderRows] = useState(cart?.orderRows);
    const {discountRows} = cart;

    useEffect(() => {
        setOrderRows(cart?.orderRows);
    }, [cart]);

    const { payload } = useSelector((state) => state.checkout);
    const { authenticated } = payload;
    
    const ProductName = useCallback(({order}) => {
        return (
            <Fragment>
                <a className="checkout-cart__name" href={order.url}>{order.name}</a>
                <span className="checkout-cart__brand-name">{order.brand}</span>
                {order.placement &&
                    <span
                        className="checkout-cart__placement">{translate('checkout.cart.placement')} {order.placement}</span>
                }
            </Fragment>
        );
    }, []);
    
    const ProductTotalPrice = ({order}) => {
        return (
            <Fragment>
                {order.isFreeGift ? order.totalCampaignPrice : order.totalPrice}
            </Fragment>
        );
    };

    const CartTotal = useCallback(({cart}) => {
        return (
            <h3 className="text--right">
                {translate('checkout.cart.total')}: {cart.orderTotal}
            </h3>
        );
    }, []);
    
    return (
        <>
            <ul className="cart__list">
                <div className="cart__list-header">
                    <div className="cart__item-row">
                        <div className="cart__item-column cart__item-column--info-container">
                            {translate('checkout.cart.header.product')}
                        </div>
                        <div className="cart__item-column cart__item-column--price">
                            {authenticated && translate('checkout.cart.header.price')}
                        </div>
                        <div className="cart__item-column cart__item-column--quantity">
                            {translate('checkout.cart.header.quantity')}
                        </div>
                        <div className="cart__item-column cart__item-column--price">
                            {authenticated && translate('checkout.cart.header.total')}
                        </div>
                    </div>
                </div>

                {orderRows.map((order) => (
                    <li className="cart__list-item" key={`cart-row-${order.rowSystemId}`}>
                        <CartItemRow order={order}/>
                    </li>
                ))}
            </ul>
            <div className="small-12 simple-table simple-table--checkout hide-for-small-only">
                {discountRows.map((order) => (
                    <div
                        className="row small-unstack no-margin checkout-cart__row"
                        key={order.rowSystemId}
                    >
                        <div className="columns small-12 medium-4 large-5 checkout-cart__image-container">
                            <div className="checkout-cart__discount-info checkout-cart__discount-row">
                                <ProductName order={order}/>
                            </div>
                        </div>
                        <div className="columns small-3 medium-2 large-2 simple-table__cell--no-break-word"></div>
                        <div className="columns small-2 medium-2 large-2"></div>
                        <div
                            className="checkout-cart__discount-price columns small-2 medium-3 large-2 simple-table__cell--no-break-word">
                            {authenticated && <ProductTotalPrice order={order}/>}
                        </div>
                        <div className="columns small-3 medium-1 large-1"></div>
                    </div>
                ))}
                <div className="row small-unstack no-margin checkout-cart__row">
                    <div className="columns">
                        {authenticated && <CartTotal cart={cart}/>}
                    </div>
                </div>
            </div>
            <div className="small-12 simple-table checkout-mobile show-for-small-only">
                {discountRows.map((order) => (
                    <div className="row no-margin" key={order.rowSystemId}>
                        <div className="columns">
                            <div className="checkout-cart__discount-row">
                                <ProductName order={order}/>
                            </div>
                            <div className="checkout-cart__discount-price text--right">
                                {authenticated && <ProductTotalPrice order={order}/>}
                            </div>
                        </div>
                    </div>
                ))}
                <div className="row no-margin">
                    <div className="columns">
                        {authenticated && <CartTotal cart={cart}/>}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Cart;
